import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
// import './config/firebaseConfig';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Provider } from 'react-redux';
import App from './App';
import toolkitStore from './redux/toolkitStore';
import ToastManager from './utils/ToastManager';
import { registerServiceWorker } from './utils/serviceWorker';


ReactDOM.render(
  <Provider store={toolkitStore}>
    <ToastManager defaultPosition="topRight" defaultBackgroundColor="blue">
      <App />
    </ToastManager>
  </Provider>,
  document.getElementById('root')
);

registerServiceWorker();

//RIGHT CLICK DISABLED
// import React from 'react';
// import ReactDOM from 'react-dom';
// import './index.css';
// // import './config/firebaseConfig';
// import App from './App';
// import { Provider } from 'react-redux';
// import store from './redux/store';
// import 'bootstrap/dist/css/bootstrap.min.css';

// const disableRightClick = (e) => {
//   e.preventDefault();
// };

// document.addEventListener('DOMContentLoaded', () => {
//   document.addEventListener('contextmenu', disableRightClick);
// });

// ReactDOM.render(
//   <Provider store={store}>
//     <App />
//   </Provider>,
//   document.getElementById('root')
// );